export const MAX_RTE_POLICY_RANK_SECONDARY_MAPPING = [
  '12',
  '13',
  '14',
  '15',
  '16',
  '41',
  '42',
  '43',
  '47',
]

export const MAX_RTE_POLICY_RANK_PRIMARY_MAPPING = [
  'AP',
  'C1',
  'CO',
  'CP',
  'D',
  'DB',
  'EP',
  'FF',
  'GP',
  'HM',
  'HN',
  'HS',
  'IN',
  'IP',
  'LC',
  'LD',
  'LI',
  'LT',
  'MA',
  'MB',
  'MC',
  'MH',
  'MI',
  'MP',
  'OT',
  'PE',
  'PL',
  'PP',
  'PR',
  'PS',
  'QM',
  'RP',
  'SP',
  'TF',
  'WC',
  'WU',
]

export const MAX_POLICY_RANKS = {
  PRIMARY: 'Primary',
  SECONDARY: 'Secondary',
}
export const MAX_POLICY_STATUS = {
  ELIGIBLE: 'ELIGIBLE',
  Current: 'Current',
}
export const MAX_POLICY_SOURCE = 'maxRTE'

export const MAX_RTE_PLANS_CONSTANTS = {
  HEALTH_BENEFIT_PLAN_COVERAGE: 'Health Benefit Plan Coverage',
  ACTIVE_COVERAGE: 'Active Coverage',
  ACTIVE_STATUS_CODE: '1',
  PHARMACY_NAME: 'Pharmacy',
}

export const MAX_RTE_CONSTANTS = {
  LABELS: {
    MAXTE_REQUEST_DATE_TIME: 'MaxRTE Request Date-Time',
    ERROR_MESSAGE: 'Error Message',
    POLICY_STATUS: 'Policy Status',
    POLICY_RANK: 'Policy Rank',
    POLICY_SOURCE: 'Policy Source',
    PAYER_NAME: 'Payer Name',
    PAYER_TYPE: 'Payer Type',
    PLAN_NAME: 'Plan Name',
    POLICY_ID: 'Policy ID',
    GROUP_ID: 'Group ID',
    ELIGIBILITY_START_DATE: 'Effective Date',
    ELIGIBILITY_END_DATE: 'Expiration Date',
    PBM_NAME: 'PBM Name',
    PBM_PHONE: 'PBM Phone',
    RX_BIN: 'Rx BIN',
    RX_PCN: 'Rx PCN',
    RX_GROUP: 'Rx Group',
    BENEFITS_LIST: 'Benefits List',
    EFFECTIVE_START_DATE: 'Effective Start Date',
    EFFECTIVE_END_DATE: 'Effective End Date',
    EXTERNAL_TRACE_ID: 'External TraceID',
  },
  KEYS: {
    MAXTE_REQUEST_DATE_TIME: 'maxrte_request_date',
    ERROR_MESSAGE: 'error_message',
    ERRORS: 'errors',
    POLICY_STATUS: 'policy_status',
    POLICY_RANK: 'policy_rank_id',
    POLICY_SOURCE: 'policy_source_id',
    PAYER_NAME: 'payer_name',
    PAYER_TYPE: 'payer_type',
    PLAN_NAME: 'plan_name',
    POLICY_ID: 'policy_id',
    GROUP_ID: 'group_id',
    ELIGIBILITY_START_DATE: 'eligibility_start_date',
    ELIGIBILITY_END_DATE: 'eligibility_end_date',
    PBM_NAME: 'pbm_name',
    PBM_PHONE: 'pbm_phone',
    RX_BIN: 'rx_bin',
    RX_PCN: 'rx_pcn',
    RX_GROUP: 'rx_group',
    BENEFITS_LIST: 'benefits_list',
    EFFECTIVE_START_DATE: 'effective_start_date',
    EFFECTIVE_END_DATE: 'effective_end_date',
    EXTERNAL_TRACE_ID: 'external_id',
  },
} as const
